var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.TiptapToolbarBtn, {
    attrs: {
      iconClass: "bi-image",
      command: () => {
        _setup.emit("open-image-modal")
      },
      "is-active": _vm.editor.isActive("image"),
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }